import { Injectable } from '@angular/core';

import { BaseEditService, HttpService, NotificationService } from '../../../../tms-shared';
import { CustomerAddress, CustomerAddressEdit } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class CustomerAddressService extends BaseEditService<CustomerAddress, CustomerAddressEdit> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('CustomerAddress', $localize`Customer Address`, httpService, notificationService);
  }
}
